export const GET_OVERTIME_RULES_BEGIN = 'GET_OVERTIME_RULES_BEGIN'
export const GET_OVERTIME_RULES_SUCCESS = 'GET_OVERTIME_RULES_SUCCESS'
export const GET_OVERTIME_RULES_ERROR = 'GET_OVERTIME_RULES_ERROR'

export const DELETE_OVERTIME_RULE_BEGIN = 'DELETE_OVERTIME_RULE_BEGIN'
export const DELETE_OVERTIME_RULE_SUCCESS = 'DELETE_OVERTIME_RULE_SUCCESS'
export const DELETE_OVERTIME_RULE_ERROR = 'DELETE_OVERTIME_RULE_ERROR'

export const APPLY_OVERTIME_RULE_BEGIN = 'APPLY_OVERTIME_RULE_BEGIN'
export const APPLY_OVERTIME_RULE_SUCCESS = 'APPLY_OVERTIME_RULE_SUCCESS'
export const APPLY_OVERTIME_RULE_ERROR = 'APPLY_OVERTIME_RULE_ERROR'